module.exports = __webpack_public_path__ + "img/jobUnsel.117d2522.svg";